import { render } from "./ClassFilterDialog.vue?vue&type=template&id=3a8d5a46&scoped=true&ts=true"
import script from "./ClassFilterDialog.vue?vue&type=script&lang=ts"
export * from "./ClassFilterDialog.vue?vue&type=script&lang=ts"

import "./ClassFilterDialog.vue?vue&type=style&index=0&id=3a8d5a46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8d5a46"]])

export default __exports__